const BASE_TREE = [
  {
    name: "仪表盘",
    code: "dash_board",
    path: "/",
    index: "1-1",
    backend:
      "business/configure/info,user/importantMetrics,user/feedback/count,user/groupData,user/lineChartData,user/groupByCountry,/user/importantMetrics",
    icon: require("@/assets/images/dashboard_nor@2x.png"),
    activeIcon: require("@/assets/images/dashboard_sel@2x.png"),
    // 'children': [
    //   {
    //     'name': '仪表盘',
    //     'path': '/',
    //     'code': 'dash_board_item',
    //     'backend': 'business/configure/info,user/importantMetrics,user/feedback/count,user/groupData,user/lineChartData,user/groupByCountry',
    //   }
    // ]
  },
  {
    name: "平台管理",
    index: "1-2",
    code: "platform_manage",
    icon: require("@/assets/images/pm_nor@2x.png"),
    children: [
      {
        name: "商户管理",
        path: "/institution",
        code: "merchant_manage",
        backend: "business/list",
        children: [
          {
            name: "商户状态变更",
            code: "merchant_state_change",
            backend: "business/edit/configure",
          },
          {
            name: "商户创建",
            code: "merchant_creat",
            backend: "business/add,business/detail",
          },
          {
            name: "商户详情",
            // 'path': '/merchant',
            code: "merchant_detail",
            isquery: true,
            backend: "business/detail",
            isHorizontal: true,
            children: [
              {
                name: "商户类型修改",
                code: "merchant_type",
                isHorizontal: true,
              },
              {
                name: "联系人修改",
                code: "merchant_contact",
                isHorizontal: true,
              },
              {
                name: "联系电话修改",
                code: "merchant_phone",
                isHorizontal: true,
              },
              {
                name: "商户邮箱设置",
                code: "merchant_email",
                isHorizontal: true,
              },
              {
                name: "商户密匙查看",
                code: "merchant_key",
                isHorizontal: true,
              },
              {
                name: "对接方式配置",
                code: "merchant_config",
                isHorizontal: true,
              },
            ],
          },
        ],
      },
      {
        name: "机构管理",
        path: "/merchant",
        code: "organize_manage",
        backend: "business/all,business/institution/list",
        isquery: true,
        children: [
          {
            name: "机构编辑",
            code: "organize_edit",
            backend: "business/institution/add,business/institution/delete",
          },
        ],
      },
    ],
  },
  {
    name: "用户中心",
    code: "user_center",
    index: "1-3",
    children: [
      {
        name: "用户管理",
        path: "/user",
        code: "user_manage",
        backend: "user/list,user/listCountries",
        children: [
          {
            name: "用户详情",
            // 'path': '/user'
            code: "user_detail",
            backend:
              "user/collect,user/detail,user/healthData,user/vip/list,user/follower,user/collect,user/device/history,user/bpData,user/hrData,user/hrvData,user/boData,user/sleepData,user/sportData,user/stepData,user/heatData,user/weightData",
          },
        ],
      },
      // {
      //   'name': '用户详情',
      //   // 'path': '/user'
      //   'code': 'user_detail',
      //   'backend': 'user/collect,user/detail,user/healthData,user/vip/list'
      // },
      // {
      //   name: "会员中心",
      //   path: "/vipCenter",
      //   code: "vip_center",
      //   backend: "vip/list",
      // },
    ],
    icon: require("@/assets/images/usercenter_nor@2x.png"),
  },
  {
    name: "会员中心",
    code: "vip_center",
    index: "1-9",
    children: [
      {
        name: "会员管理",
        path: "/vipManage",
        code: "vip_manage",
        backend: "vip/data/briefing,vip/data/statistic",
        children: [],
      },
      {
        name: "订阅记录",
        path: "/subscribeRecords",
        code: "subscribe_records",
        backend: "vip/subscribe/record",
        children: [
          {
            name: "订阅详情",
            path: "/subscribeDetail",
            code: "subscribe_detail",
            backend: "vip/subscribe/details",
          },
        ],
      },
      {
        name: "支付记录",
        path: "/paymentRecords",
        code: "payment_records",
        backend: "vip/record",
        children: [
          {
            name: "支付详情",
            path: "/paymentDetail",
            code: "payment_detail",
            backend: "vip/order/details",
          },
          {
            name: "下载",
            code: "pay_down",
          },
          {
            name: "退款",
            code: "pay_refund",
            backend: "vip/refund",
          },
        ],
      },
      {
        name: "兑换记录",
        path: "/exchangeRecords",
        code: "exchange_records",
        backend: "vip/record",
      },
      {
        name: "领取记录",
        path: "/collectionRecords",
        code: "collection_records",
        backend: "vip/record",
      },
      {
        name: "会员列表",
        path: "/vipList",
        code: "vip_list",
        backend: "vip/users",
      },
      {
        name: "兑换码管理",
        path: "/redeem",
        code: "redeem_manage",
        backend: "vip/all,vip/exchange/code/list",
        children: [
          {
            name: "生成",
            code: "creat_redeem",
            backend: "vip/exchange/code/add",
          },
          {
            name: "下载",
            code: "down_redeem",
            backend: "vip/exchange/code/list",
          },
          {
            name: "作废",
            code: "del_redeem",
            backend: "vip/exchange/code/void",
          },
        ],
      },
      {
        name: "发送兑换码",
        path: "/redeemEmail",
        code: "redeem_email",
        backend: "vip/all,vip/exchange/code/list,vip/exchange/code/email",
      },
      {
        name: "权益中心",
        path: "/equityCenter",
        code: "equity_center",
        backend: "vip/benefits",
      },
      {
        name: "会员配置",
        path: "/vipConfiguration",
        code: "vip_configuration",
        backend: "vip/all",
      },
    ],
    icon: require("@/assets/images/usercenter_nor@2x.png"),
  },
  {
    name: "营销中心",
    code: "marketing_center",
    index: "1-8",
    children: [
      {
        name: "营销管理",
        path: "/marketingCenter",
        code: "marketing_manage",
        backend: "promotion/count/statistics,promotion/page",
        children: [
          {
            name: "创建活动",
            code: "create_activity",
            path: "/activeCreat",
            backend: "promotion/add",
          },
          {
            name: "活动详情",
            path: "/activityDetail",
            code: "activity_detail",
            backend:
              "promotion/days/statistics,promotion/user,promotion/get,promotion/data/briefing,promotion/count/device,promotion/daily/data,promotion/user/del",
          },
          {
            name: "编辑活动",
            code: "edit_activity",
            backend:
              "promotion/update,promotion/device/data,/promotion/count/statistics,promotion/device/import,promotion/device/del,promotion/device/add",
          },
        ],
      },
    ],
    icon: require("@/assets/images/salemanagement_nor@2x.png"),
  },
  {
    name: "设备管理",
    index: "1-4",
    code: "device_manage",
    children: [
      {
        name: "设备列表",
        path: "/dev",
        code: "device_list",
        backend: "device/lists,business/tree",
        children: [
          {
            name: "设备详情",
            // 'path': '/dev',
            isShow: false,
            code: "device_detail",
            backend:
              "device/detail,device/electricity/lists,business/tree,aftersales/order/list,device/user/lists",
            children: [
              {
                name: "所属商户修改",
                code: "change_merchant",
                backend: "device/edit/configure",
              },
              {
                name: "生产批次修改",
                code: "production_number_edit",
                backend: "device/edit/configure",
              },
              {
                name: "语言修改",
                code: "language_edit",
                backend: "device/edit/configure",
              },
              {
                name: "生产厂商修改",
                code: "manufacturer_edit",
                backend: "device/edit/configure",
              },
              {
                name: "领取状态重置",
                code: "receive_status_edit",
                backend: "device/vip/status/reset",
              },
              {
                name: "保修期修改",
                code: "warranty_edit",
              },
              {
                name: "翻新",
                code: "refurbish",
                backend: "device/refurbish",
              },
            ],
          },
          {
            name: "添加设备",
            code: "dev_add",
            backend: "device/add",
          },
          {
            name: "批量导入",
            code: "dev_import",
            backend: "device/import",
          },
          {
            name: "配置",
            code: "dev_config",
            backend: "device/edit/configure",
          },
          {
            name: "下载",
            code: "dev_download",
            backend: "device/lists",
          },
          {
            name: "删除",
            code: "dev_del",
            backend: "device/del",
          },
        ],
      },
      {
        name: "固件管理",
        path: "/ota",
        code: "ota_manage",
        backend: "business/configure/info,project/list",
        children: [
          {
            name: "固件详情",
            path: "/project",
            code: "ota_detail",
            backend: "business/configure/info,project/list",
            children: [
              {
                name: "项目详情",
                path: "/otaList",
                code: "project_detail",
                backend: "business/configure/info,project/list,ota/list",
                children: [
                  {
                    name: "上传OTA文件",
                    code: "upload_ota_file",
                    backend: "ota/create",
                  },
                  {
                    name: "更新提示配置",
                    code: "update_tip",
                  },
                  {
                    name: "下载",
                    code: "ota_download",
                    backend: "ota/file/url",
                  },
                  {
                    name: "删除",
                    code: "ota_del",
                    backend: "ota/delete",
                  },
                ],
              },
              {
                name: "添加项目",
                code: "ota_project_add",
                backend: "project/edit",
              },
              {
                name: "添加",
                code: "ota_add",
                backend: "ota/create",
              },
              {
                name: "编辑",
                code: "ota_edit",
                backend: "project/edit",
              },
              {
                name: "设备与用户",
                code: "ota_dev_user",
                backend: "user/list,device/lists,ota/conf/list,ota/conf/add,ota/conf/del",
              },
            ],
          },
        ],
      },
      {
        name: "表盘管理",
        path: "/dial",
        code: "dial_manage",
        backend: "dial/list",
        children: [
          {
            name: "上传表盘文件",
            code: "upload_dial_file",
            backend: "dial/create",
          },
          {
            name: "编辑",
            code: "dial_edit",
            backend: "dial/update",
          },
          {
            name: "删除",
            code: "dial_del",
            backend: "dial/delete",
          },
        ],
      },
    ],
    icon: require("@/assets/images/devicemanage_nor@2x.png"),
  },
  {
    name: "售后中心",
    index: "1-5",
    code: "after_sales_center",
    children: [
      {
        name: "售后管理",
        path: "/aftersalemanage",
        code: "after_sales_manage",
        backend: "aftersales/order/list,aftersales/order/info",
        children: [
          // {
          //   'name': '售后单',
          //   'path': '/afterSaleOrder',
          //   'code': 'after_sale_orderpage',
          // },
          {
            name: "新建售后单",
            code: "creat_after_sales",
            backend: "aftersales/order/add,device/detail",
          },
          {
            name: "待我处理",
            // 'path': '/aftersalemanage',
            code: "wait_to_handle",
            children: [
              {
                name: "待收货预检",
                code: "wait_recive_pre_check",
              },
              {
                name: "待审核",
                code: "wait_audit",
              },
              {
                name: "待维修",
                code: "wait_repair",
              },
              {
                name: "待退回",
                code: "wait_return",
              },
              {
                name: "待寄出",
                code: "wait_send",
              },
            ],
          },
          {
            name: "售后单详情",
            code: "after_sales_order",
            backend: "aftersales/order/edit",
            children: [
              {
                name: "取消售后单",
                code: "concole_after_sales",
              },
              {
                name: "收货预检",
                code: "recive_pre_check",
              },
              {
                name: "审核",
                code: "audit",
              },
              {
                name: "维修",
                code: "repair",
              },
              {
                name: "退回",
                code: "return",
              },
              {
                name: "寄出",
                code: "send",
              },
            ],
          },
        ],
      },
    ],
    icon: require("@/assets/images/aftersale_nor@2x.png"),
  },
  {
    name: "客服中心",
    index: "1-6",
    code: "cus-service_center",
    icon: require("@/assets/images/callcenter_nor@2x.png"),
    children: [
      {
        name: "用户反馈",
        path: "/feedback",
        code: "feedback",
        backend: "user/feedback,user/listCountries,user/listFeedbackTypes",
        children: [
          {
            path: "/feedbackDetail",
            code: "feedbackDetail",
            name: "反馈详情",
            isquery: true,
            backend:
              "user/listFeedbackTypes,user/feedback/detail,user/deviceList",
            children: [
              {
                name: "消息回复",
                code: "message_reply",
                backend: "user/chat,user/postMessage,user/assumeRole",
              },
              {
                name: "状态修改",
                code: "state_change",
                backend: "user/updateFeedbackStatus",
              },
              {
                name: "备注",
                code: "remark",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "系统管理",
    code: "system_manage",
    index: "1-7",
    children: [
      {
        name: "账号管理",
        path: "/member",
        code: "member_manage",
        backend: "user/admin/list,user/roleList",
        children: [
          {
            name: "新建账号",
            code: "creat_account",
            backend: "user/addAdmin",
          },
          {
            name: "删除账号",
            code: "del_account",
            backend: "user/removeAdmin",
          },
          {
            name: "配置角色",
            code: "update_user_role",
            backend: "user/roleList",
          },
          {
            name: "账号详情",
            path: "/member",
            code: "account_detail",
            backend: "user/roleList,user/admin/get",
            children: [
              {
                name: "手机号修改",
                code: "phonenumber_edit",
              },
              {
                name: "姓名修改",
                code: "name_edit",
              },
              {
                name: "邮箱设置",
                code: "email_edit",
              },
              {
                name: "登陆密码修改",
                code: "password_edit",
              },
            ],
          },
        ],
      },
      {
        name: "角色管理",
        path: "/roleManage",
        code: "role_manage",
        backend: "user/roleList,user/admin/list",
        children: [
          {
            name: "创建角色",
            code: "creat_role",
            backend: "user/addRole",
          },
          {
            name: "修改角色",
            code: "edit_role",
            backend: "user/editRole",
          },
          {
            name: "删除角色",
            code: "del_role",
            backend: "user/removeRole",
          },
        ],
      },
    ],
    icon: require("@/assets/images/systemmanage_nor@2x.png"),
  },
];

export default {
  BASE_TREE,
};
